import { Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

export interface InvalidPlanDialogProps {
  onClose: () => void;
}

export const InvalidPlanDialog = ({ onClose }: InvalidPlanDialogProps) => {
  return (
    <BaseDialog
      title="Você ainda não pode iniciar este plano"
      onClose={onClose}
      icon={<Icon name="siren-rounded" />}
      actionsComponent={
        <>
          <Button onClick={onClose}>Fechar</Button>
          <Button variant="contained" onClick={onClose}>
            Entendi
          </Button>
        </>
      }
    >
      <Typography>
        Para iniciar o plano é necessário definir a duração e adicionar pelo
        menos uma atividade.
      </Typography>
    </BaseDialog>
  );
};
